import {DomainError} from '@s-ui/domain'

export class GetMakesWithModelsVehiclesError extends DomainError {
  #cause
  #code
  #message

  static GENERIC_ERROR_CODE = 'generic_get_makes_with_models_vehicles_error'

  constructor({cause, code, message}) {
    super({cause, code, message})
    this.#cause = cause
    this.#code = code
    this.#message = message
  }

  static isGetMakesWithModelsVehiclesError({error}) {
    return error instanceof GetMakesWithModelsVehiclesError
  }

  static create({code, message, cause}) {
    return new GetMakesWithModelsVehiclesError({code, message, cause})
  }

  static createGenericError({cause}) {
    return GetMakesWithModelsVehiclesError.create({
      code: GetMakesWithModelsVehiclesError.GENERIC_ERROR_CODE,
      cause,
      message: 'ERRORS.GET_MAKES_WITH_MODELS_VEHICLES.GENERIC'
    })
  }

  get value() {
    return {
      code: this.#code,
      message: this.message,
      cause: this.cause
    }
  }

  isGenericError() {
    return this.#code === GetMakesWithModelsVehiclesError.GENERIC_ERROR_CODE
  }

  toJSON() {
    return {
      code: this.#code,
      message: this.#message,
      cause: this.#cause
    }
  }
}
